<div class="row page-header">
    <div class="col-12">
        <h1>Bid History <small>View historical bid information to improve future bidding</small></h1>
    </div>
</div>
@if (!isInitialLoading) {
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Bid History'"></grid-export>
                        <div style="margin-left: auto; display: flex; gap: 0.5rem; align-items: center">
                            <grid-export
                                [grid]="mainGrid"
                                [name]="'Bid History'"
                                [snakeCaseHeaders]="true"
                                [noNumberFormatting]="true"
                            ></grid-export>
                            <button type="button" class="btn btn-sm btn-secondary" (click)="showAll = !showAll; filterItems()">
                                {{ showAll ? 'Hide Non-Bid' : 'Show Non-Bid' }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        [padding]="73"
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemFormatter]="mainGridItemFormatter"
                        (beginningEdit)="cellBeginningEdit(mainGrid, $event)"
                        (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                        (pasting)="pasting(mainGrid, $event)"
                        (pasted)="pasted(mainGrid, $event)"
                        [itemsSource]="grid.view"
                        [keyActionTab]="'CycleEditable'"
                        [frozenColumns]="3"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Was Bid'" [binding]="'wasBid'" [width]="70"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Heavy Bid #'"
                            [binding]="'heavyBidNum'"
                            [width]="100"
                            [format]="'D'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [width]="250"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Bids'" [binding]="'competitorBids'" [width]="90" [isReadOnly]="true">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                <a
                                    href="javascript:void(0)"
                                    (click)="openCompetitorBidsModal(item)"
                                    [class.text-muted]="!item.competitorBids || item.competitorBids.length === 0"
                                    style="cursor: pointer; text-decoration: underline"
                                >
                                    {{ getBiddersCount(item) }}
                                </a>
                            </ng-template>
                        </wj-flex-grid-column>
                        <!--<wj-flex-grid-column [header]="'Owner (Old)'" [binding]="'owner'" [width]="150"></wj-flex-grid-column>-->
                        <wj-flex-grid-column
                            [header]="'Owner'"
                            [binding]="'ownerId'"
                            [width]="200"
                            [dataMap]="ownersMap"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <!--<wj-flex-grid-column [header]="'Bid Type (Old)'" [binding]="'bidType'" [width]="150"></wj-flex-grid-column>-->
                        <wj-flex-grid-column
                            [header]="'Bid Type'"
                            [binding]="'bidTypeId'"
                            [width]="180"
                            [dataMap]="jobTypeMap"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'County'"
                            [binding]="'countyId'"
                            [width]="150"
                            [dataMap]="countiesMap"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <!--<wj-flex-grid-column [header]="'Estimator (Old)'" [binding]="'estimator'" [width]="110"></wj-flex-grid-column>-->
                        <wj-flex-grid-column
                            [header]="'Estimator'"
                            [binding]="'estimatorHrRef'"
                            [width]="160"
                            [dataMap]="allUserMap"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Bid Date'"
                            [binding]="'bidDate'"
                            [width]="130"
                            [editor]="inputDate"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Completion Date'"
                            [binding]="'completionDate'"
                            [width]="130"
                            [editor]="inputDate"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Abstracts'" [binding]="'bidAbstracts'" [width]="150" [isReadOnly]="true">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                @if (item.bidAbstracts && item.bidAbstracts.length > 0) {
                                    @for (file of item.bidAbstracts; track file.id; let last = $last) {
                                        <a href="javascript:void(0)" (click)="openAbstract(file.url)" title="{{ file.fileName }}">{{
                                            file.fileName
                                        }}</a>
                                        @if (!last) {
                                            <span>, </span>
                                        }
                                    }
                                } @else {
                                    <span class="text-muted">None</span>
                                }
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Labor % Cost Factor'"
                            [binding]="'laborPercentCostFactor'"
                            [width]="100"
                            [format]="'P2'"
                            [isRequired]="false"
                            [dataType]="'Number'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Avg Mark Up %'"
                            [binding]="'averageMarkUpPercent'"
                            [width]="100"
                            [format]="'P2'"
                            [isRequired]="false"
                            [dataType]="'Number'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Mark Up'" [binding]="'markUp'" [width]="100" [format]="'C0'"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Overhead Add On'"
                            [binding]="'overheadAddOn'"
                            [width]="110"
                            [format]="'C0'"
                            [dataType]="'Number'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Equip OP Exp'"
                            [binding]="'equipOpExp'"
                            [width]="100"
                            [format]="'C0'"
                            [dataType]="'Number'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'CO Equip'"
                            [binding]="'coEquip'"
                            [width]="100"
                            [format]="'C0'"
                            [dataType]="'Number'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'High'"
                            [binding]="'high'"
                            [width]="100"
                            [format]="'C0'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Low'"
                            [binding]="'low'"
                            [width]="100"
                            [format]="'C0'"
                            [isRequired]="false"
                            [isReadOnly]="true"
                            [dataType]="'Number'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Won'"
                            [binding]="'won'"
                            [width]="100"
                            [format]="'C0'"
                            [isRequired]="false"
                            [isReadOnly]="true"
                            [dataType]="'Number'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'VanCon'"
                            [binding]="'vanCon'"
                            [width]="100"
                            [format]="'C0'"
                            [isRequired]="false"
                            [isReadOnly]="true"
                            [dataType]="'Number'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Rank'"
                            [binding]="'rank'"
                            [width]="80"
                            [isRequired]="false"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Lost By'"
                            [binding]="'lostBy'"
                            [width]="100"
                            [format]="'C0'"
                            [isReadOnly]="true"
                            [dataType]="'Number'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'% Over'"
                            [binding]="'percentOver'"
                            [width]="100"
                            [format]="'P2'"
                            [isReadOnly]="true"
                            [dataType]="'Number'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Number Bidders'"
                            [binding]="'numBidders'"
                            [width]="100"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'PQ'"
                            [binding]="'bidOutlookDto.pq'"
                            [width]="55"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Plan Source'"
                            [binding]="'bidOutlookDto.planSource'"
                            [width]="150"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'D.B. Wages'"
                            [binding]="'bidOutlookDto.davisBaconWages'"
                            [width]="80"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Engineer Estimate'"
                            [binding]="'bidOutlookDto.bidRangeId'"
                            [width]="155"
                            [dataMap]="rangeMap"
                            [isRequired]="false"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>

                        <wj-flex-grid-column
                            [header]="'Notice To Proceed Date'"
                            [binding]="'bidOutlookDto.noticeToProceed'"
                            [width]="155"
                            [isRequired]="false"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>

                        <wj-flex-grid-column
                            [header]="'Competitor Ids'"
                            [binding]="'bidOutlookDto.competitorIdString'"
                            [width]="155"
                            [isRequired]="false"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>

                        <wj-flex-grid-column
                            [header]="'Deep'"
                            [binding]="'bidOutlookDto.isDeep'"
                            [width]="155"
                            [isRequired]="false"
                            [isReadOnly]="true"
                        >
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                <input
                                    type="checkbox"
                                    [checked]="item.bidOutlookDto && item.bidOutlookDto.isDeep === true"
                                    (click)="onCheckboxChange($event)"
                                    [indeterminate]="item.bidOutlookDto === undefined || item.bidOutlookDto?.isDeep === null"
                                /> </ng-template
                        ></wj-flex-grid-column>

                        <wj-flex-grid-column
                            [header]="'Traffic Control'"
                            [binding]="'bidOutlookDto.hasTrafficControl'"
                            [width]="155"
                            [isRequired]="false"
                            [isReadOnly]="true"
                        >
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                <input
                                    type="checkbox"
                                    [checked]="item.bidOutlookDto && item.bidOutlookDto.hasTrafficControl === true"
                                    (click)="onCheckboxChange($event)"
                                    [indeterminate]="item.bidOutlookDto === undefined || item.bidOutlookDto?.hasTrafficControl === null"
                                /> </ng-template
                        ></wj-flex-grid-column>

                        <wj-flex-grid-column
                            [header]="'Dewatering'"
                            [binding]="'bidOutlookDto.hasDewatering'"
                            [width]="155"
                            [isRequired]="false"
                            [isReadOnly]="true"
                        >
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                <input
                                    type="checkbox"
                                    [checked]="item.bidOutlookDto && item.bidOutlookDto.hasDewatering === true"
                                    (click)="onCheckboxChange($event)"
                                    [indeterminate]="item.bidOutlookDto === undefined || item.bidOutlookDto?.hasDewatering === null"
                                /> </ng-template
                        ></wj-flex-grid-column>

                        <wj-flex-grid-column
                            [header]="'Bypass Pumping'"
                            [binding]="'bidOutlookDto.hasBypassPumping'"
                            [width]="155"
                            [isRequired]="false"
                            [isReadOnly]="true"
                        >
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                <input
                                    type="checkbox"
                                    [checked]="item.bidOutlookDto && item.bidOutlookDto.hasBypassPumping === true"
                                    (click)="onCheckboxChange($event)"
                                    [indeterminate]="item.bidOutlookDto === undefined || item.bidOutlookDto?.hasBypassPumping === null"
                                /> </ng-template
                        ></wj-flex-grid-column>

                        <wj-flex-grid-column
                            [header]="'Tight Time Frame'"
                            [binding]="'bidOutlookDto.hasTightTimeFrame'"
                            [width]="155"
                            [isRequired]="false"
                            [isReadOnly]="true"
                        >
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                <input
                                    type="checkbox"
                                    [checked]="item.bidOutlookDto && item.bidOutlookDto.hasTightTimeFrame === true"
                                    (click)="onCheckboxChange($event)"
                                    [indeterminate]="item.bidOutlookDto === undefined || item.bidOutlookDto?.hasTightTimeFrame === null"
                                /> </ng-template
                        ></wj-flex-grid-column>

                        <wj-flex-grid-column
                            [header]="'Tight Job Site'"
                            [binding]="'bidOutlookDto.isTightJobSite'"
                            [width]="155"
                            [isRequired]="false"
                            [isReadOnly]="true"
                        >
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                <input
                                    type="checkbox"
                                    [checked]="item.bidOutlookDto && item.bidOutlookDto.isTightJobSite === true"
                                    (click)="onCheckboxChange($event)"
                                    [indeterminate]="item.bidOutlookDto === undefined || item.bidOutlookDto?.isTightJobSite === null"
                                /> </ng-template
                        ></wj-flex-grid-column>

                        <wj-flex-grid-column
                            [header]="'Haul Off'"
                            [binding]="'bidOutlookDto.hasHaulOff'"
                            [width]="155"
                            [isRequired]="false"
                            [isReadOnly]="true"
                        >
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                <input
                                    type="checkbox"
                                    [checked]="item.bidOutlookDto && item.bidOutlookDto.hasHaulOff === true"
                                    (click)="onCheckboxChange($event)"
                                    [indeterminate]="item.bidOutlookDto === undefined || item.bidOutlookDto?.hasHaulOff === null"
                                /> </ng-template
                        ></wj-flex-grid-column>

                        <wj-flex-grid-column
                            [header]="'Insurance Requirement'"
                            [binding]="'bidOutlookDto.hasInsuranceRequirement'"
                            [width]="155"
                            [isRequired]="false"
                            [isReadOnly]="true"
                        >
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
                                <input
                                    type="checkbox"
                                    [checked]="item.bidOutlookDto && item.bidOutlookDto.hasInsuranceRequirement === true"
                                    (click)="onCheckboxChange($event)"
                                    [indeterminate]="
                                        item.bidOutlookDto === undefined || item.bidOutlookDto?.hasInsuranceRequirement === null
                                    "
                                /> </ng-template
                        ></wj-flex-grid-column>
                    </wj-flex-grid>

                    <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
                    <wj-input-date #inputDate [isRequired]="false"></wj-input-date>
                </div>
            </div>
        </div>
    </div>
}
